import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import SwipeableViews from 'react-swipeable-views'
import { Tabs, Tab } from '@material-ui/core'
import { allowMobileOutlineToggle } from 'Utils/featureFlags'
import L from '../L'
import Type from '../Type'
import LaunchCard from './Components/LaunchCard'
import { LAUNCH_CARDS } from './constants'
import AccountActions from '../../Redux/AccountRedux'
import Switch from '../Switch'
import { TabHeader, StyledDialog, configuratorStyles, ConfigControlsContainer } from './Components/Configurator-styles'

const enhance = compose(withRouter, withStyles(configuratorStyles))

const Configurator = ({ collection, simulation, variant, onClose }) => {
  const profile = useSelector(({ firebase }) => firebase.profile)
  const dispatch = useDispatch()

  const [index, setIndex] = useState(0)
  const [tabs, setTabs] = useState([])
  const [shouldHideMobileOutline, setShouldHideMobileOutline] = useState(false)

  const setProfileOptions = params => {
    dispatch(AccountActions.AccountSetProfileOptions(params))
  }
  const setSimulation = (...rest) => {
    dispatch(AccountActions.AccountSetSimulation(...rest))
  }

  const renderLaunchCards = () => {
    const noMobileExperience = simulation.mobileToggle === 'false'
    const launchCardArray = []
    LAUNCH_CARDS.map((card, idx) => {
      if (
        variant === 'executive' && card.urlSuffix === 'center-display'
          ? !noMobileExperience
          : variant === 'one'
          ? !card.hideInOne
          : true
      ) {
        launchCardArray.push(
          <L key={`launchCard_${idx}`} width="100%" height="100%" display="grid" ji="center">
            <LaunchCard
              profile={profile}
              collection={collection}
              simulation={simulation}
              variant={variant}
              setProfileOptions={setProfileOptions}
              shouldHideMobileOutline={shouldHideMobileOutline}
              {...card}
            />
          </L>,
        )
      }
    })
    return launchCardArray
  }

  const renderConfigControls = () => {
    if (allowMobileOutlineToggle(simulation)) {
      return (
        <ConfigControlsContainer>
          <Switch
            color="primary"
            checked={shouldHideMobileOutline}
            onChange={() => setShouldHideMobileOutline(!shouldHideMobileOutline)}
          />
          <Type variant="body1">
            <label htmlFor="shouldHideMobileOutline">Hide Mobile Outline</label>
          </Type>
        </ConfigControlsContainer>
      )
    }
    return ''
  }

  const renderTabs = () => {
    const noMobileExperience = simulation.mobileToggle === 'false'
    const tabArray = []

    tabs.map((tab, idx) => {
      const Icon = tab.icon
      if (variant === 'executive' && tab.urlSuffix === 'center-display' ? !noMobileExperience : true) {
        tabArray.push(
          <Tab
            key={`tab_${idx}`}
            label={<Icon color={idx === index ? '#E11C8E' : '#0D0D0D'} style={{ transition: 'color .2s ease-in' }} />}
          />,
        )
      }
    })

    return variant !== 'one' ? (
      <L display={{ md: 'none' }}>
        <TabHeader>
          <Tabs
            className="configurator"
            value={index}
            onChange={(e, newIndex) => setIndex(newIndex)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            {tabArray}
          </Tabs>
        </TabHeader>
      </L>
    ) : null
  }

  useEffect(() => {
    return () => {
      setSimulation(collection && collection.id, simulation.id, null, true, true)
      const newTabs = Array.from(LAUNCH_CARDS, card => ({
        icon: card.noMobileCardIcon && simulation.mobileToggle === 'false' ? card.noMobileCardIcon : card.cardIcon,
        urlSuffix: card.urlSuffix,
      }))
      setTabs(newTabs)
    }
  }, [])

  return (
    <StyledDialog onClose={onClose} aria-labelledby="simulation-configurator" open maxWidth={false}>
      <L minX={{ xx: '100%', md: '455px' }}>
        <L pY={1.5} pL={2} pR={5} position="relative" bgColor="primary">
          <Type variant="h5Upper">{variant === 'one' ? 'One' : 'Multi'} Visualizer Configurator</Type>
          {onClose ? (
            <L center="absolute" l="auto" r="15px" display="flex" ai="center">
              <CloseIcon aria-label="Close" onClick={onClose} />
            </L>
          ) : null}
        </L>
        <L>
          {renderTabs()}
          <L display="grid" flow="column" ji="center" autoColumns="1fr" gap={1.5} pY={{ xx: 1.5, lg: 3 }} pX={1.5}>
            <L display={{ xx: 'none', md: 'contents' }}>{renderLaunchCards()}</L>
            <L display={{ xx: 'contents', md: 'none' }}>
              <SwipeableViews index={index} style={{ maxWidth: '100%' }} onChangeIndex={setIndex}>
                {renderLaunchCards()}
              </SwipeableViews>
            </L>
          </L>
          {renderConfigControls()}
        </L>
      </L>
    </StyledDialog>
  )
}

export default enhance(Configurator)
